module.exports = __webpack_public_path__ + "static/icon-seller-e01be0bbc5dbcab603b5d08345ec8b0f.png";